import { TextBody } from '@zappyrent/hundop';
import React from 'react';

import { StyledH3 } from '../TextPageLandlord/TextPageLandlord.styles';

const ComeAffittareCasa = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        Come affittare casa con Zappyrent
      </StyledH3>
      <TextBody>
        Chi decide di mettere in affitto una proprietà di qualsiasi genere si
        trova di fronte diversi problemi riguardanti principalmente il
        comportamento dei conduttori che, nella maggior parte dei casi, sono
        persone sconosciute.
      </TextBody>
      <TextBody>
        Non si può avere la certezza che queste si prendano cura dell’immobile
        senza produrre danni, né che paghino puntualmente il canone e neppure
        che, al termine del contratto, lascino la casa in buone condizioni.
      </TextBody>
      <TextBody>
        <strong>
          Con Protezione Zappyrent ottieni la garanzia di ricevere un affitto
          sicuro,
        </strong>{' '}
        il servizio è vantaggioso per entrambi contraenti poiché Zappyrent si
        pone come intermediario gestendo tutte le operazioni richieste.
      </TextBody>
      <TextBody>
        Dopo essersi iscritto al portale e aver caricato il proprio annuncio, il
        proprietario non deve fare altro che aspettare le richieste di
        prenotazione dell’alloggio che Zappyrent si occupa di selezionare.
      </TextBody>
      <TextBody>
        <strong>Tutto si può svolgere completamente on-line</strong> in quanto
        gli inquilini possono effettuare un tour virtuale dell’immobile e
        visionare il relativo dossier di foto, ma possono anche richiedere la
        visita fisica dell’alloggio.
      </TextBody>
      <TextBody>
        Se il contratto viene stipulato,{' '}
        <strong>
          Zappyrent si occupa dell’intera gestione dei pagamenti mensili,
        </strong>{' '}
        versandoli direttamente sull’account del locatore.
      </TextBody>
      <TextBody>
        A tutela di entrambe le parti{' '}
        <strong>Zappyrent procede a congelare il deposito cauzionale</strong>{' '}
        per l’intera durata del contratto nel momento stesso del suo versamento.{' '}
        <strong>
          I proprietari hanno così la certezza di poter contare su una cifra
          sempre disponibile
        </strong>{' '}
        in caso di danneggiamento dell’immobile, mentre agli inquilini è
        garantita la restituzione dell’intera cifra al termine del contratto,
        senza nessuna trattenuta. In caso di morosità, invece, è protezione
        Zappyrent a far si che il proprietario riceva il canone ogni mese.
      </TextBody>
    </>
  );
};

export default ComeAffittareCasa;
